<template>
    <div v-if="isMounted && !loading">
      <vs-tabs v-if="projects.length > 0" v-model="activeTab" color="warning" alignment="fixed" class="tab-action-btn-fill-container">
        <vs-tab v-for="(project, i) in projects" :key="i" :label="project.project_id+'-'+project.alias">
          <div class="tab-text">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-4">
                    <h4 style="margin-bottom: 0px; margin-top: 15px;"><strong>{{project.project_id}} | {{project.alias}}</strong></h4> 
                  </div>

                  <div v-if="project.dues.length > 0" class="col-xs-12 col-sm-6 col-md-4 text-center">
                      <p><strong>Generar históricos.</strong></p>
                      <vs-button color="#4caf50" class="mr-1" type="line" line-origin="left" @click="actionsHistoricalDue('add','penalty',project.project_id)" v-if="!loading">Penalización</vs-button>
                      <vs-button color="#4caf50" class="mr-1" type="line" line-origin="left" @click="actionsHistoricalDue('add','moratorium',project.project_id)" v-if="!loading">Moratorios</vs-button>
                      <vs-button color="#4caf50" type="line" line-origin="left" @click="actionsHistoricalDue('add','all',project.project_id)" v-if="!loading">Ambos</vs-button>
                  </div> 

                  <div v-if="project.dues.length > 0" class="col-xs-12 col-sm-6 col-md-4 text-center">
                      <p><strong>Eliminar históricos.</strong></p>
                      <vs-button color="danger" class="mr-1" type="line" line-origin="left" @click="actionsHistoricalDue('remove','penalty',project.project_id)" v-if="!loading">Penalización</vs-button>
                      <vs-button color="danger" class="mr-1" type="line" line-origin="left" @click="actionsHistoricalDue('remove','moratorium',project.project_id)" v-if="!loading">Moratorios</vs-button>
                      <vs-button color="danger" type="line" line-origin="left" @click="actionsHistoricalDue('remove','all',project.project_id)" v-if="!loading">Ambos</vs-button>
                  </div>             
                </div>
                <br>
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="thead-dark">
                      <tr>
                          <th>Mes</th>
                          <th>Adeudo</th>
                          <th>Amortización</th>
                          <th>Interés</th>
                          <th>IVA</th>
                          <th>Penalización</th>
                          <th>IVA penalización</th>
                          <th>Intereses moratorios</th>
                          <th>IVA intereses moratorios</th>
                          <th>Comisión</th>
                          <th>IVA comisión</th>
                          <th>Penalizado</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(due, d) in project.dues" :key="d">
                          <td>{{due.payment_date|human_date}}</td>
                          <td class="table-number">${{formatPrice(due.due, 2)}}</td>
                          <td class="table-number">${{formatPrice(due.amortization, 2)}}</td>
                          <td class="table-number">${{formatPrice(due.interest, 2)}}</td>
                          <td class="table-number">${{formatPrice(due.tax, 2)}}</td>
                          <td v-if="due.penalized == 1"><input class="table-number" type="number" @keyup.enter="update({number: due.payment_date, amount: due.penalty, field:'penalty', project: due.project_id, projectAlias: due.alias})" v-model="due.penalty"></td>
                          <td class="table-number" v-else>${{formatPrice(due.penalty, 2)}}</td>
                          <td class="table-number">${{formatPrice(due.penalty_tax, 2)}}</td>
                          <td><input type="number" class="table-number" @keyup.enter="update({number: due.payment_date, amount: due.moratorium_interest, field: 'moratorium_interest', project: due.project_id, projectAlias: due.alias})" v-model="due.moratorium_interest"></td>
                          <td class="table-number">${{formatPrice(due.moratorium_interest_tax, 2)}}</td>
                          <td><input type="number" class="table-number" @keyup.enter="update({ number: due.payment_date, amount: due.client_comission, field: 'client_comission', project: due.project_id, projectAlias: due.alias})" v-model="due.client_comission"></td>
                          <td class="table-number">${{formatPrice(due.client_comission_tax, 2)}}</td>
                          <td v-if="due.penalized === 0"><button @click="penalize({penalize: 1,  number: due.payment_date, project: due.project_id, projectAlias: due.alias})"  class="btn btn-danger"  v-if="!loading">Penalizar</button></td>
                          <td v-else>Si</td>
                      </tr>
                      <tr class="table-active">
                        <td class="bold">Total Adeudos</td>
                          <td class="table-number bold">${{formatPrice(project.total.due, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.amortization, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.interest, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.tax, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.penalty, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.penalty_tax, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.moratorium_interest, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.moratorium_interest_tax, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.client_comission, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.total.client_comission_tax, 2)}}</td>
                          <td></td>
                      </tr>
                      <tr class="table-danger">
                          <td class="table-number bold">Saldo Total</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.due, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.amortization, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.interest, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.tax, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.penalty, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.penalty_tax, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.moratorium_interest, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.moratorium_interest_tax, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.client_comission, 2)}}</td>
                          <td class="table-number bold">${{formatPrice(project.totalHistoric.client_comission_tax, 2)}}</td>
                          <td></td>
                      </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>  
          </div>
        </vs-tab>
      </vs-tabs>
      <div v-else>
        <vs-alert icon-pack="feather" icon="icon-info" class="h-full my-4" color="primary">
          <span>No hay datos disponibles.</span>
        </vs-alert>
      </div>
    </div>
</template>

<script>
    import {formatPrice} from '../../../../components/admin/filters.js';
    import * as moment from 'moment'
    export default {
        name: "DuesProject",
        props:['project_id'],
        async mounted(){
            await this.getInformation();
            this.isMounted=true;
        },
        data(){
            return {
                loading:false,
                isMounted: false,
                projects: [],
                activeTab: 0,
                total:{},
                money: {
                    decimal: '.',
                    thousands: ',',
                    prefix: '$',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
            }
        },
        filters: {
            human_date(date) {
                return moment(date).lang("es").format("MMM YYYY");
            }

        },
        methods: {
            formatPrice,
            async getInformation(){
                this.loading = true
                this.projects = []
                await axios.get('/api/cobranza/adeudo/' + this.project_id + '/desgloce').then(response => {
                    this.projects = response.data;
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                });
            },
            async update(due){
              var reason = '';
              do{
                reason = prompt('Motivos:');
                if(reason != null && reason != ''){
                  //var value = due.amount;
                  var message = ` a $${this.formatPrice(due.amount, 2)} con IVA  de $${this.formatPrice(due.amount * 0.16)} correspondiente al mes ${due.number}, del proyecto ${due.project}-${due.projectAlias} \nMotivos:  ${reason}.\nConfirma con tu segundo factor de autenticación:`;
                  var fa_error = false
                  var fa = ''
                  do{
                    if(due.field == 'moratorium_interest'){
                      fa =  prompt('Cambio de interés moratorio' + message, '');
                    }else if(due.field == 'penalty'){
                      fa =  prompt('Cambio de penalización' + message, '');
                    }else{
                      fa =  prompt('Cambio de comisión' + message, '');
                    }
                    fa_error =  false;
                    if(fa !=  null && fa != ''){
                      this.loading =  true
                      try {
                        var res = await axios.post('/api/cobranza/adeudo/recargos', {
                            amount: due.amount,
                            payment_date: due.number,
                            project_id: due.project,
                            focus_project: due.project,
                            code : fa,
                            reason: reason,
                            field: due.field,
                        });
                        this.$emit('updated', 1)
                      } catch (e) {
                        if(e.response.data.message != undefined){
                          this.errorNotif("Aviso", e.response.data.message, 4000);
                        }else{
                          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                        }
                        if(e.response.data.errors != undefined && e.response.data.errors['2fa'] !=undefined ){
                          fa_error = true;
                        }
                      }
                      this.loading = false
                    }
                  }while (fa_error);
                }
              }while(reason == '');
            },
            async penalize(due){
              var reason = '';
              do{
                reason = prompt('Motivos:');
                if(reason != null && reason != ''){
                  var fa =  prompt(`Penalizar mes ${due.number}, del proyecto ${due.project}-${due.projectAlias}.\nConfirma con tu segundo factor de autenticación:`, '');
                  if(fa !=  null && fa != ''){
                      this.loading = true
                      this.showLoading(true);
                      await axios.post('/api/cobranza/adeudo/penalizar', {
                          project_id: due.project,
                          focus_project: due.project,
                          penalize: due.penalize,
                          payment_date: due.number,
                          code : fa,
                          reason:reason
                      }).then(response => {
                          this.showLoading(false);
                          //this.getInformation()
                          this.$emit('updated', 1)
                      }).catch(error => {
                          this.showLoading(false);
                          if (error?.response?.data?.message != undefined) {
                              this.errorNotif("Aviso", error.response.data.message, 4000);
                          } else {
                              this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                          }
                      });
                      this.loading = false;
                  }
                }
              }while(reason == '');
            },
            async actionsHistoricalDue(action,option,project_id){
              var reason = '';
              do{
                reason = prompt('Motivos:');
                if(reason != null && reason != ''){
                  let message = `Generación de recargos históricos.\nMotivos: ${reason} \nConfirma con tu segundo factor de autenticación:`;
                  let urlRequest = '/api/cobranza/adeudo/recargos/agregarHistorico';
                  if (action == "remove") {
                    message = `Eliminacíon de recargos históricos.\nMotivos: ${reason} \nConfirma con tu segundo factor de autenticación:`;
                    urlRequest = '/api/cobranza/adeudo/recargos/removerHistorico';                    
                  }

                  var fa =  prompt(message, '');
                  if(fa !=  null && fa != ''){
                    try{
                      this.showLoading(true);
                      // this.loading = true;
                      await axios.post(urlRequest, {
                        project_id: project_id,
                        code : fa,
                        option: option,
                        reason: reason
                      });
                      this.$emit('updated', 1);
                      this.successNotif("Aviso", 'Operación exitosa.');
                    }catch(error){
                      if(error.response.data.message != undefined){
                          this.errorNotif("Aviso", error.response.data.message, 4000);
                      }else{
                          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                      }
                    }
                  }
                  this.showLoading(false);
                  // this.loading = false
                }              
              }while(reason == '');
            },
            parseFormat(amount){
                let s = amount.replace('$', '')
                s = s.replace(',', '')
                s = s.replace(',', '')
                s = s.replace(',', '')
                let parsed  = parseFloat(s)
                return  parsed;
            }
        }
    }
</script>

<style scoped>
    td > input{
        max-width: 100px;
        border:none;
    }
    
    td, th
    {
        text-align: center; 
        vertical-align: middle;
    }
.table {
    margin-bottom: 0;
}

.table-responsive {
	border-radius: 10px;
}

</style>